import { Form, Formik, FormikConfig } from "formik";
import { object, string } from "yup";
import React from "react";
import { ButtonWithLoader } from "../../general/ButtonWithLoader/ButtonWithLoader";
import { Button } from "../../general/Button/Button";

import { StandardModalHeader } from "../../general/Modal/Modal";
import { Category } from "../../../common/types/category";
import { submitHelper } from "../../../helpers/form";
import { FormRow } from "../../forms/FormRow";

export interface CategorySchema {
    label: string;
    description: string | null;
}

interface CategoryFormProps {
    category?: Category;
    onHide: () => void;
    isPending: boolean;
    onSubmitCategory: (data: CategorySchema) => Promise<unknown>;
}

export const CategoryForm: React.FC<CategoryFormProps> = ({
    category,
    onHide,
    isPending,
    onSubmitCategory,
}) => {
    const formConfig: FormikConfig<CategorySchema> = {
        initialValues: {
            label: category?.label ?? "",
            description: category?.description ?? "",
        },
        validationSchema: object().shape({
            label: string().required(),
        }),
        onSubmit: submitHelper({
            loading: isPending,
            handler: async (data) => {
                await onSubmitCategory({
                    description: data.description ?? null,
                    label: data.label,
                });
                onHide();
            },
        }),
        validateOnMount: true,
    };

    return (
        <>
            <StandardModalHeader>
                {category ? "Update" : "Create"} category
            </StandardModalHeader>
            <Formik {...formConfig}>
                {(formik) => (
                    <Form>
                        <FormRow fieldName="label" label="Label" size="sm" />
                        <FormRow
                            fieldName="description"
                            label="Description"
                            size="sm"
                        />

                        <footer className="d-flex justify-content-end gap-2">
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={onHide}
                                size="lg"
                                data-testid="change-description-modal-no-button"
                            >
                                Cancel
                            </Button>

                            <ButtonWithLoader
                                variant="default"
                                loading={isPending}
                                size="lg"
                                data-testid="change-description-modal-yes-button"
                                disabled={!formik.isValid}
                            >
                                {category ? "Save changes" : "Create category"}
                            </ButtonWithLoader>
                        </footer>
                    </Form>
                )}
            </Formik>
        </>
    );
};
